import React from "react";
import { View, Text, StyleSheet, Pressable } from "react-native";
import { DotsIcon, LeftArrowIcon } from "./Icons";
import { colors } from "./Shared";

interface Props {
  title: string;
  onBack?: () => void;
  onPressDots: () => void;
}
export default function ChatHeaderComponent({ title, onBack, onPressDots }: Props) {
  return (
    <View style={styles.container}>
      {onBack && (
        <Pressable style={styles.icon} onPress={onBack}>
          <LeftArrowIcon />
        </Pressable>
      )}
      <View style={styles.content}>
        <Text style={styles.size}>{title}</Text>
      </View>
      <Pressable style={styles.icon} onPress={onPressDots}>
        {/* <DotsIcon /> */}
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 50,
    backgroundColor: colors.bg.light,
    flexDirection: "row",
    position: "relative",
  },
  icon: {
    display: "flex",
    paddingHorizontal: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    flex: 1,
    justifyContent: "center",
    paddingLeft: 10,
  },
  size: {
    fontSize: 20,
    textTransform: "capitalize"
  },
});
